// extracted by mini-css-extract-plugin
export default {"products":"zy-z","card":"Ay-z","oosMessaging":"By-z"};